<div class="bm-card bm-card-sm bm-card-border border-base-300">
  <div class="bm-card-body">
    @if (heading) {
      <div class="bm-card-title text-sm">{{ heading }}</div>
    }

    <!-- Typ-Auswahl. Bei Staging-Configs nur PickPoint/Technikerversand. -->
    <div class="flex gap-1 mb-3 flex-wrap">
      @for (t of visibleShippingTypes(); track t.value) {
        <button class="bm-btn bm-btn-xs" type="button"
          [class.bm-btn-primary]="selectedType() === t.value"
          [disabled]="isTypeDisabled(t.value)"
          [title]="typeDisabledReason(t.value) || t.label"
          (click)="setShippingType(t.value)">
          <fa-icon [icon]="t.icon" class="mr-1" />{{ t.label }}
        </button>
      }
    </div>

    <!-- PickPoint Auswahl -->
    @if (selectedType() === 'pickpoint') {
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">PickPoint-Station</label>
        <div class="flex flex-row gap-2 items-center">
          <div class="flex-1 flex items-center gap-2 min-h-[2.25rem]">
            @if (selectedStation(); as sel) {
              <span class="bm-badge bm-badge-neutral">PP-{{ sel.pp_id }}</span>
              <span>{{ sel.name }}</span>
              @if (sel.address_zip || sel.address_city) {
                <span class="opacity-60 text-sm">{{ sel.address_zip }} {{ sel.address_city }}</span>
              }
            } @else {
              <span class="opacity-60 italic">Nicht ausgewählt</span>
            }
          </div>
          <button class="bm-btn bm-btn-ghost" type="button"
                  [disabled]="!canOpenMap()"
                  [title]="canOpenMap() ? 'Auf Karte auswählen' : 'Kein Auftragsort mit Koordinaten verfügbar'"
                  (click)="showMapPicker.set(true)">
            <fa-icon [icon]="iconMap" class="mr-1" />
            Auf Karte wählen
          </button>
        </div>
      </fieldset>

      <!-- PM-Code: Pflichtfeld bei PickPoint. Liegt grundsaetzlich im
           erweiterten Bereich (siehe unten) — wird beim Anlegen aus dem
           System-User (ID 1) vorbelegt; bei manuellen Korrekturen klickt
           der User die Sektion auf. -->
    }

    <!-- Filialversand -->
    @if (selectedType() === 'store_shipping') {
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Ziel-Filiale (aus Ticket)</label>
        <div class="min-h-[2.25rem] flex items-center gap-2">
          @if (context?.ticket_store_nr) {
            <span>{{ context?.ticket_store_nr }}</span>
            @if (context?.ticket_store_name) {
              <span class="opacity-60">{{ context?.ticket_store_name }}</span>
            }
          } @else if (ticketStoreId) {
            <span class="opacity-60 italic">Filiale wird geladen…</span>
          } @else {
            <span class="opacity-60 italic">Keine Filiale am Ticket</span>
          }
        </div>
      </fieldset>
    }

    <!-- Kundenversand: Rueckadresse-Info -->
    @if (selectedType() === 'customer_shipping') {
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Rücksendeadresse des Kunden</label>
        @if (!context) {
          <div class="text-sm opacity-60 italic">Rücksendeadresse wird geprüft…</div>
        } @else if (context.customer_has_return_address) {
          <div class="bm-alert bm-alert-success bm-alert-soft">
            <fa-icon [icon]="iconCheck" class="mr-2" />
            Rücksendeadresse ist hinterlegt@if (context.customer_name) { bei <strong>{{ context.customer_name }}</strong> }.
          </div>
        } @else {
          <div class="bm-alert bm-alert-error bm-alert-soft">
            <fa-icon [icon]="iconTimes" class="mr-2" />
            <div>
              Keine Rücksendeadresse beim Kunden hinterlegt – Kundenversand nicht möglich.
              @if (context.customer_id) {
                <a class="bm-link bm-link-hover ml-1" [routerLink]="['/kunde', context.customer_id]" target="_blank">
                  Zur Kundenseite
                </a>
              }
            </div>
          </div>
        }
      </fieldset>
    }

    <!-- Versandart + Paket-Geschwindigkeit (eine Zeile, beide inhaltsbreit) -->
    <div class="flex gap-x-6 mt-2 flex-wrap">
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Versandart</label>
        <div class="flex gap-1 flex-wrap">
          @for (m of visibleShipmentMethods(); track m.value) {
            <button class="bm-btn bm-btn-xs" type="button"
              [class.bm-btn-primary]="shipmentMethod() === m.value"
              (click)="setShipmentMethod(m.value)">
              <fa-icon [icon]="m.icon" class="mr-1" />{{ m.label }}
            </button>
          }
        </div>
      </fieldset>

      @if (shipmentMethod() === 'parcel') {
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Paket-Geschwindigkeit</label>
          <div class="flex gap-1 flex-wrap">
            @for (s of packageSpeeds; track s.value) {
              <button class="bm-btn bm-btn-xs" type="button"
                [class.bm-btn-primary]="packageSpeed() === s.value"
                (click)="packageSpeed.set(s.value)">
                <fa-icon [icon]="s.icon" class="mr-1" />{{ s.label }}
              </button>
            }
          </div>
        </fieldset>
      }
    </div>

    @if (selectedType() === 'store_shipping') {
      <!-- Artikel-Disposition (nur bei Filialversand waehlbar) -->
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Artikel bei Versand</label>
        <div class="flex gap-1 flex-wrap">
          <button class="bm-btn bm-btn-xs" type="button"
                  [class.bm-btn-primary]="articleDisposition() === 'technician_transfer'"
                  (click)="articleDisposition.set('technician_transfer')">
            Auf Techniker umbuchen
          </button>
          <button class="bm-btn bm-btn-xs" type="button"
                  [class.bm-btn-primary]="articleDisposition() === 'consumed'"
                  (click)="articleDisposition.set('consumed')">
            Verbraucht (installiert)
          </button>
        </div>
      </fieldset>
    }

    <!-- Versanddatum bleibt im Hauptbereich (haeufig genutzt) -->
    <div class="mt-2">
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Versanddatum (optional)</label>
        <input class="bm-input w-full" type="date"
          [ngModel]="shippingDate()"
          (ngModelChange)="shippingDate.set($event || '')" />
        <span class="text-xs opacity-60 mt-1">{{ shippingDateHint }}</span>
      </fieldset>
    </div>

    <!-- Erweiterte Einstellungen (collapsible): Ziel-Techniker, Ziel-Lager,
         Notizen, optional PM-Code (wenn aus System-User geladen). -->
    <div class="mt-2 border-t border-base-200 pt-2">
      <button type="button"
              class="bm-btn bm-btn-ghost bm-btn-sm"
              (click)="showAdvancedSection.set(!showAdvancedSection())">
        {{ showAdvancedSection() ? '▾' : '▸' }} Erweiterte Einstellungen
      </button>

      @if (showAdvancedSection()) {
        <div class="mt-2 flex flex-col gap-2">
          <!-- PM-Code: bei PickPoint immer hier, mit Hilfetext je nachdem
               ob er vom System vorbelegt wurde oder nicht. -->
          @if (selectedType() === 'pickpoint') {
            <fieldset class="bm-fieldset">
              <label class="bm-fieldset-label">PM-Code <span class="text-error">*</span></label>
              <input class="bm-input w-full" type="text" placeholder="z.B. PM-692636"
                     [ngModel]="pmCode()" (ngModelChange)="pmCode.set($event)" />
              <span class="text-xs opacity-60 mt-1">
                @if (pmCodeAutoLoaded()) {
                  Aus dem System-User vorbelegt — nur ändern, wenn der Kunde einen abweichenden Code vorgibt.
                } @else {
                  Vom Kunden vorgegebener Code, identifiziert den Abholberechtigten an der Station.
                }
              </span>
            </fieldset>
          }

          <!-- Ziel-Techniker + Ziel-Lager -->
          @if (showTechnicianSelector()) {
            <div class="grid gap-x-2" [class.grid-cols-2]="targetUserId() != null" [class.grid-cols-1]="targetUserId() == null">
              <fieldset class="bm-fieldset">
                <label class="bm-fieldset-label">Ziel-Techniker</label>
                <select class="bm-select w-full" [ngModel]="targetUserId()" (ngModelChange)="onTechnicianChange($event)">
                  <option [ngValue]="null">-- Techniker auswählen --</option>
                  @for (tech of technicians(); track tech.id) {
                    <option [ngValue]="tech.id">{{ tech.name }}</option>
                  }
                </select>
              </fieldset>

              @if (targetUserId() != null) {
                <fieldset class="bm-fieldset">
                  <label class="bm-fieldset-label">Ziel-Lager des Technikers</label>
                  @if (loadingWarehouses()) {
                    <div class="text-sm opacity-60 italic min-h-[2.25rem] flex items-center">Lade Lager…</div>
                  } @else if (technicianWarehouses().length === 0) {
                    <div class="text-sm opacity-60 italic min-h-[2.25rem] flex items-center">Kein Lager verfügbar</div>
                  } @else {
                    <select class="bm-select w-full" [ngModel]="targetWarehouseId" (ngModelChange)="targetWarehouseId = $event">
                      <option [ngValue]="null">-- Lager auswählen --</option>
                      @for (w of technicianWarehouses(); track w.id) {
                        <option [ngValue]="w.id">{{ w.label }}</option>
                      }
                    </select>
                  }
                </fieldset>
              }
            </div>
          }

          <fieldset class="bm-fieldset">
            <label class="bm-fieldset-label">Notizen</label>
            <input class="bm-input w-full" type="text" placeholder="Optional"
              [(ngModel)]="configNotes" />
          </fieldset>
        </div>
      }
    </div>

    <!-- Aktionen -->
    <div class="flex gap-2 mt-3 justify-end">
      <button class="bm-btn bm-btn-ghost bm-btn-sm" type="button" (click)="cancel.emit()">
        Abbrechen
      </button>
      <button class="bm-btn bm-btn-primary bm-btn-sm" type="button"
              (click)="emitSave()" [disabled]="!canSave()">
        {{ saveLabel }}
      </button>
    </div>
  </div>
</div>

<!-- PickPoint-Karten-Popup -->
@if (showMapPicker() && canOpenMap()) {
  <hawk-pickpoint-map-picker
    [centerLat]="ticketLat!"
    [centerLng]="ticketLng!"
    [referenceDate]="referenceDate"
    [initialStationId]="selectedStation()?.id"
    (stationSelected)="onMapStationPicked($event)"
    (closed)="showMapPicker.set(false)"
  />
}
